module.exports = __webpack_public_path__ + "static/media/Olivia Chen.bff0e63e.png";